import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "../../context/AuthContext";

/**
 * PublicRoute component that redirects authenticated users away from
 * public routes like login and OTP verification
 */
const PublicRoute = ({ children }) => {
  const { user } = useAuth();
  const location = window.location.pathname;

  // Special case: Allow access to OTP page even when authenticated but without a role
  // This handles the flow from login -> OTP verification
  if (location === "/otp" && user && !user.user_type) {
    return children;
  }

  // If user is authenticated, redirect to appropriate dashboard
  if (user) {
    // Determine where to redirect based on user role
    let userRole = user.user_type;

    // Redirect based on role
    switch (userRole) {
      case "admin":
        if (window.navigator.userAgent.includes("ZoomApps")) {
          window.location.href = "/agent";
        }
        return <Navigate to="/admin" replace />;
      case "backofficesupport":
        return <Navigate to="/agent" replace />;
      case "supervisor":
        if (window.navigator.userAgent.includes("ZoomApps")) {
          return <Navigate to="/agent" replace />;
        }
        return <Navigate to="/admin" replace />;
      case "customer":
        return <Navigate to="/customer" replace />;
      case "agent":
        window.location.href = "/agent";
        return <Navigate to="/agent" replace />;
      case "interpreter":
        return <Navigate to="/interpreter" replace />;
      default:
        // Fallback to a general dashboard if role is unknown
        return <Navigate to="/" replace />;
    }
  }

  // If not authenticated, show the requested public route
  return children;
};

export default PublicRoute;
